import React, { useState, useEffect, useRef } from "react";
import Questions from "./questions";
import Countdown from "./countdown";
import { type } from "@testing-library/user-event/dist/type";

const App = (prop) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(0);
  const [response, setResponse] = useState([]);
  const [query, setQuery] = useState("");
  const [queryLang, setQueryLang] = useState(
    prop.lang == "pl" ? "POLSKI" : "ENGLISH"
  );
  const [languages, setLanguages] = useState([
    "ENGLISH",
    "POLSKI",
    "SPANISH",
    "GERMAN",
    "UKRAINIAN",
    "CZECH",
    "GREEK",
    "ITALIAN",
    "FRENCH",
    "PORTUGUESE",
    "BULGARIAN",
    "SWEDISH",
    "CHINESE",
    "HINDI",
    "BENGALI",
    "RUSSIAN",
    "JAPANESE",
    "JAVANESE",
    "KOREAN",
    "VIETNAMESE",
    "TELUGU",
    "MARATHI",
    "TAMIL",
    "TURKISH",
    "URDU",
    "GUJARATI",
    "ARABIC",
    "CHINESE",
    "MALAYALAM",
    "KANNADA",
    "ORIYA",
    "SUNDA",
    "ROMANIAN",
    "BHOJPURI",
    "AZERBAIJANI",
    "MAITHILI",
    "HAUSA",
    "BURMESE",
    "SERBO-CROATIAN",
    "AWADHI",
    "THAI",
    "DUTCH",
    "YORUBA",
    "SINDHI",
    "MALAY",
    "AMHARIC",
    "INDONESIAN",
    "IGBO",
    "TAGALOG",
    "NEPALI",
    "SARAIKI",
    "CEBUANO",
    "THAI",
    "ASSAMESE",
    "HUNGARIAN",
    "CHITTAGONIAN",
    "MADURA",
    "SINHALA",
    "HARYANVI",
    "MARWARI",
    "MAGAHI",
    "CHHATTISGARHI",
    "DECCAN",
    "BELARUSAN",
    "SOMALI",
    "MALAGASY",
    "RWANDA",
    "ZULU",
    "LOMBARD",
    "KAZAKH",
    "ILOCANO",
    "TATAR",
    "SHONA",
  ]);
  const inputRef = useRef(null);

  useEffect(() => {
    // Focus on the input field when the component mounts
    inputRef.current.focus();
  }, []);
  const isJson = function (str) {
    try {
      const data = JSON.parse(str);
      return true;
    } catch (err) {
      return false;
    }
  };

  const ignoreDuplicatesAndAddNewQuestions = function (arr) {
    const newQuestions = [];
    for (let i = 0; i < arr.length; i++) {
      let add = true;
      for (let j = 0; j < response.length; j++) {
        console.log(i, j);
        if (response[j].question === arr[i].question) {
          //takie pytanie juz jest

          add = false;
          break;
        }
      }
      if (add) {
        newQuestions.push(arr[i]);
      }
    }
    // console.log(arr, x);
    setResponse(response.concat(newQuestions));
  };

  const toCamelCase = function (str) {
    return str.replace(/[-_](.)/g, function (match, group1) {
      return group1.toUpperCase();
    });
  };

  const generateText = async (e) => {
    e.preventDefault();

    const apiKey = "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"; // Podaj swój klucz API OpenAI

    const data = {
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "user",
          content:
            "Provide survey questionnaire:\n" +
            '- survey goal/topic: "' +
            query +
            '"\n' +
            // "- answer in the language: " +
            // (navigator.language || navigator.userLanguage) +
            // "\n" +
            "- return 10 different questions \n" +
            "- return survey questions in the " +
            queryLang +
            " lanuage\n" +
            "- show possible answers to questions\n" +
            "- use the following question types: single choice, multiple choice, open\n" +
            '- give information about question types with possible values: "single", "multiple", "open"\n' +
            '- return result as JSON with the following structure [{"id":1,"type":"single","question":"How old are you?", "answer":["10","20","30"]},{"id":2,"type":"multiple", "question":"What do you like to eat", "answer":["a","b","c"],{"id":3, "type":"open", "question":"What is your name?","answer":[]}}]\n' +
            "- return only JSON",
        },
        // {
        //   role: "user",
        //   content:
        //     "Przygotuj propozycję pytań do ankiety.\n" +
        //     '- cel ankiety: zbadać "' +
        //     query +
        //     '"\n' +
        //     "- pytania przygotuj w jezyku" +
        //     (navigator.language || navigator.userLanguage) +
        //     "\n" +
        //     "- pokaż 10 rónych pytań\n" +
        //     "- przedstaw możliwe odpowiedzi na pytania\n" +
        //     "- użyj następujące rodzaje pytań: jednokrotnego wyboru, wielokrotnego wyboru, pytania otwarte\n" +
        //     "- oznacz czy pytanie jest jednokrotnego wyboru, wielokrotnego czy otwarte\n" +
        //     '- zwróć wynik jako JSON o takiej strukturze [{"id:1","type":"jednokrotnego",question:"ile masz lat?", answer:["10 lat","20 lat","30 lat"]},{"id:2","type":"wielokrotnego", question:"Co lubisz jesc", answer:["a","b","c"]}]\n' +
        //     "- nie dodawaj zadnej innej tresci niz JSON",
        // },
      ],
      //   max_tokens: 50,
      temperature: 0.1,
    };

    // console.log(data);
    // return;

    try {
      setLoading(true);
      if (typeof window.amplitude !== "undefined") {
        window.amplitude.getInstance().logEvent("AI survey generator click", {
          query: query,
          queryLang: queryLang,
        });
      }

      console.log(data.messages[0].content);
      const model = "text-davinci-002";
      const xhrresponse = await fetch(
        "https://api.openai.com/v1/chat/completions",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${apiKey}`,
          },
          body: JSON.stringify(data),
        }
      );

      const responseData = await xhrresponse.json();

      //   const $ = cheerio.load(responseData.choices[0].message.content);
      //   const html = $("form").html();
      let apiResponseString = responseData.choices[0].message.content;
      if (typeof window.amplitude !== "undefined") {
        window.amplitude
          .getInstance()
          .logEvent("AI survey generator response", {
            data: apiResponseString,
          });
      }
      console.log("apiResponseString:", apiResponseString);
      if (isJson(apiResponseString)) {
        let apiResponse = JSON.parse(apiResponseString);
        console.log("ajax response", apiResponse);
        console.log("response state:", response);
        [...document.querySelectorAll("h3")]
          ?.pop()
          ?.scrollIntoView({ behavior: "smooth" });
        ignoreDuplicatesAndAddNewQuestions(apiResponse);
      } else {
        alert("No new questions or we have an issue.");
      }

      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="container">
      <div className="row m-2 mt-5">
        <form onSubmit={generateText}>
          <div className="mb-3">
            <label htmlFor="query" className="form-label">
              <h3 style={{ fontSize: "28px" }}>
                {prop.s.whatDoYouWant[prop.lang]}
              </h3>
            </label>
            <input
              ref={inputRef}
              placeholder={prop.s.surveyGoal[prop.lang]}
              onChange={(e) => setQuery(e.target.value)}
              value={query}
              style={{ fontSize: "20px" }}
              type="text"
              className="form-control form-control-lg"
              id="query"
            />
          </div>
          <div className="mb-3">
            <label htmlFor="query" className="form-label">
              <h3 style={{ fontSize: "28px" }}>
                {prop.s.showSurvey[prop.lang]}
              </h3>
            </label>
            <select
              value={queryLang}
              onChange={(e) => setQueryLang(e.target.value)}
              type="text"
              style={{ fontSize: "20px" }}
              className="form-control form-control-lg"
              id="lang"
            >
              {languages.map((el, index) => {
                return (
                  <option value={el} key={index}>
                    {el.toLowerCase()}
                  </option>
                );
              })}
            </select>
          </div>
          {/* <div className="mb-3">
            <label htmlFor="query" className="form-label">
              Your E-mail
            </label>
            <input
              placeholder=""
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              type="text"
              className="form-control form-control-lg"
              id="email"
            />
          </div> */}

          <div className="row m-2 mt-5">
            <Questions value={response} />
          </div>
          <div className="row">
            {loading ? (
              <button
                disabled
                style={{
                  background: "#009b85",
                  borderColor: "#009b85",
                  fontSize: "20px",
                }}
                className="btn btn-primary btn-lg disabled"
              >
                <Countdown label={prop.s.label[prop.lang]} />
              </button>
            ) : (
              <div>
                <button
                  type="submit"
                  style={{
                    background: "#009b85",
                    borderColor: "#009b85",
                    fontSize: "20px",
                  }}
                  className="btn btn-primary btn-lg"
                >
                  {prop.s.generate[prop.lang]}{" "}
                  {response.length > 0 ? prop.s.more[prop.lang] : ""}{" "}
                  {prop.s.surveyQuestion[prop.lang]}
                </button>
                {response.length > 0 && (
                  <a
                    style={{ fontSize: "20px" }}
                    className="btn btn-lg btn-warning m-2"
                    target="_blank"
                    href={prop.s.register[prop.lang]}
                  >
                    {prop.s.createForFree[prop.lang]}
                  </a>
                )}
              </div>
            )}
          </div>
        </form>
      </div>

      {/* <div>{JSON.stringify(response)}</div> */}
    </div>
  );
};

export default App;
